export default function({ store, redirect }) {
  // If the user is not selected any pricing package, redirect to the blast-pricing page
  if (!store.state.checkout.selectedPackage) {
    return redirect("/blast-pricing");
  }
}
